import React from 'react';
import '../styles/Hero.css';

function Hero() {
    return (
        <section className="hero" id="hero">
            <div className="hero-content">
                <h1>Antalya</h1>
                    <h2>7/24 Oto Kurtarma & Yol Yardım - 0551 497 81 61</h2>
                    <p>Hızlı, güvenilir ve uygun fiyatlı oto çekici hizmetimizle yanınızdayız! Telefon: 0551 497 81 61</p>                <div className="hero-buttons">
                    <a href="tel:+905514978161" className="call-btn"><i className="fas fa-phone-alt"></i> Bizi
                        Arayın</a>
                    <a href="https://wa.me/905514978161" className="call-btn"><i
                        className="fab fa-whatsapp"></i> WhatsApp</a>
                </div>
            </div>
        </section>
    );
}

export default Hero;
